import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { FeedScreen } from '@/features/accounting-bank/feed-screen'
import { hasGrant } from '@/lib/me'

const bankTransactionsSearch = z.object({
  bank_account_id: z.string().optional(),
  view: z.enum(['pending', 'posted', 'excluded']).default('pending'),
  page: z.number().int().min(1).catch(1),
})

function BankTransactionsScreen() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <FeedScreen
      view={search.view}
      selectedAccountId={search.bank_account_id ?? null}
      page={search.page}
      onViewChange={(view) =>
        void navigate({ search: (previous) => ({ ...previous, view, page: 1 }) })
      }
      onSelectedAccountChange={(bank_account_id) =>
        void navigate({
          search: (previous) => ({
            ...previous,
            bank_account_id: bank_account_id ?? undefined,
            page: 1,
          }),
        })
      }
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      onImportComplete={(bank_account_id) =>
        void navigate({
          search: (previous) => ({
            ...previous,
            bank_account_id: bank_account_id ?? undefined,
            view: 'pending',
            page: 1,
          }),
        })
      }
    />
  )
}

export const Route = createFileRoute('/_authenticated/accounting/bank-transactions')({
  validateSearch: bankTransactionsSearch,
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_reconciliation.view'))
      throw redirect({ to: '/accounting' })
  },
  component: BankTransactionsScreen,
})
